<template>
  <div id="contenedor-auditorias-tablero-tool-bar" class="pb-4">
    <v-toolbar flat dense>
      <div>
        <custom-select
        class="mr-2"
        v-model="filtros.enteFiscalizador"
        label="Ente Fiscalizador"
        item-value="id"
        item-text="descripcion"
        clearable
        :items="getEntesFiscalizadores">
        </custom-select>
      </div>
      <div style="width: 150px" class="mr-2">
        <ejercicio-picker
        v-model="filtros.ejercicioDel"
        class="mr-2"
        label="Del Ejercicio"
        sinPeriodo>
        </ejercicio-picker>
      </div>
      <div style="width: 150px" class="mr-2">
        <ejercicio-picker
        v-model="filtros.ejercicioAl"
        class="mr-2"
        label="Al Ejercicio"
        sinPeriodo>
        </ejercicio-picker>
      </div>
      <div>
        <custom-select
        v-model="filtros.auditoriaSelected"
        label="Auditoria"
        item-value="id"
        item-text="nombre"
        clearable
        :items="this.filtros.auditorias">
        </custom-select>
      </div>
    </v-toolbar>
    </div>
</template>

<script>
import ENTES_FISCALIZADORES from '@/graphql/querys/administracion/catalogos/entesfiscalizadores/entesFiscalizadores.gql';
import EjercicioPicker from '@/components/inputs/EjercicioPicker.vue';
import CustomSelect from '@/components/inputs/Select.vue';

export default {
  name: 'AuditoriasTableroToolBarTab',
  props: {
    filtros: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      mostrarAgregarAuditoria: false,
      mostrarAgregarEnteFiscalizador: false,
      debounce: null,
    };
  },
  apollo: {
    entesFiscalizadores: {
      query: ENTES_FISCALIZADORES,
    },
  },
  components: {
    EjercicioPicker,
    CustomSelect,
  },
  computed: {
    getEntesFiscalizadores() {
      if (!this.entesFiscalizadores) return [];
      return this.entesFiscalizadores;
    },
  },
  methods: {
  },
};
</script>

<style lang="scss">

</style>
